import { render, staticRenderFns } from "./contactBanner.vue?vue&type=template&id=52917438&scoped=true&"
import script from "./contactBanner.vue?vue&type=script&lang=js&"
export * from "./contactBanner.vue?vue&type=script&lang=js&"
import style0 from "./contactBanner.vue?vue&type=style&index=0&id=52917438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52917438",
  null
  
)

export default component.exports